import React from "react";
import "./Yardscape.css";
import { useInView } from "react-intersection-observer";
import { Button } from "../../components/Button/Button";
import SEO from "../../components/SEO";

import heroImage from "../../images/morepics/Zaid Joe - 3403 garden gate way rev_029.jpg";
import image1 from "../../images/morepics/401 Bunker Hill - The View rev_026.jpg";
import image2 from "../../images/morepics/401 Bunker Hill - The View rev_023.jpg";

export default function Yardscape() {
    const { ref: introRef, inView: introVisible } = useInView();
    const { ref: featureRef, inView: featureVisible } = useInView();

    return (
        <>
            <SEO
                title="Yardscape Design | MICO Pool Design and Consulting"
                description="Create a cohesive yardscape with planting, hardscape, privacy, drainage, and circulation plans that complete your outdoor living space."
            />
            <div
                className="yardscape"
                style={{ backgroundImage: `url(${heroImage})` }}
            >
                <h1 className="yardscape-header">YARDSCAPES</h1>
            </div>

            <section className="yardscape-content">
                <div
                    className={
                        introVisible
                            ? "yardscape-left yardscape-left-move"
                            : "yardscape-left"
                    }
                    ref={introRef}
                >
                    <h2>Thoughtful Landscapes That Complete the Space</h2>
                    <p>
                        A luxury pool environment is finished by what surrounds
                        it. We design yardscapes that shape movement, frame
                        views, and bring cohesion to your entire outdoor
                        investment with a clean, timeless look.
                    </p>
                </div>
                <div className="yardscape-right-image-wrap">
                    <img
                        className="yardscape-image"
                        src={image1}
                        alt="Custom yardscape and hardscape design around a luxury pool"
                    />
                </div>
            </section>

            <section className="yardscape-feature-strip">
                <div>
                    <h3>Planting Strategy</h3>
                    <p>Layered greenery selected for texture, scale, and year-round impact.</p>
                </div>
                <div>
                    <h3>Hardscape Balance</h3>
                    <p>Walkways, borders, and transitions that connect every outdoor zone.</p>
                </div>
                <div>
                    <h3>Low-Maintenance Luxury</h3>
                    <p>Material and layout choices that stay beautiful with practical upkeep.</p>
                </div>
            </section>

            <section className="yardscape-content yardscape-content-reverse">
                <div className="yardscape-left-image-wrap">
                    <img
                        className="yardscape-image"
                        src={image2}
                        alt="Refined backyard design integrating pool, planting, and pathways"
                    />
                </div>
                <div
                    className={
                        featureVisible
                            ? "yardscape-right yardscape-right-move"
                            : "yardscape-right"
                    }
                    ref={featureRef}
                >
                    <h2>What We Plan Into Every Yardscape</h2>
                    <ul className="yardscape-list">
                        <li>Site-aware grading and drainage considerations</li>
                        <li>Defined circulation and destination zones</li>
                        <li>Material and planting palettes matched to your architecture</li>
                        <li>Privacy, screening, and visual framing opportunities</li>
                        <li>Unified design language with your pool and patio plans</li>
                    </ul>
                    <div className="yardscape-cta">
                        <Button
                            buttonStyle="btn--outline"
                            buttonSize="btn--medium"
                            buttonLink="/contact"
                        >
                            Start Your Yardscape Design
                        </Button>
                    </div>
                </div>
            </section>
        </>
    );
}
